import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { DateFormatter } from '../../../services/Formatters';
import Editor, { TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT, NOT_APPLICABLE } from '../Editor';
import './DateEditor.scss';

class DateComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    editing: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
    form: PropTypes.bool,
    property: PropTypes.shape({}),
  }

  static defaultProps = {
    value: undefined,
    error: null,
    readOnly: false,
    label: null,
    editing: false,
    description: null,
    form: false,
    property: {},
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      const { value } = event.target;
      // Parse formatted duration
      onChange(value);
    }
  };

  render() {
    const {
      value,
      editing,
      error,
      label,
      description,
      readOnly,
      form,
      property,
    } = this.props;
    const displayValue = typeof value === 'string' ? value : DateFormatter(value, null, null, property);
    return (
      <React.Fragment>
        {editing || form ? (
          <div className="tuc-date-editor">
            <TextField
              error={!!error}
              label={form && (error || label) || undefined}
              value={displayValue}
              margin={form && 'normal' || 'dense'}
              onChange={this.handleChange}
              helperText={form && description}
              InputProps={{
                readOnly,
              }}
            />
          </div>
        ) : (
          <span>{displayValue}</span>
        )}
      </React.Fragment>
    );
  }
}

export default class DateEditor extends Editor {
  constructor(name, components) {
    super(name || 'date', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [DateComponent],
      [FORM_FIELD_COMPONENT]: [DateComponent],
    }, components));
  }

  formatValue(value, data, propName, props) {
    return value === undefined
      ? NOT_APPLICABLE : DateFormatter(value, null, null, props);
  }
}
